/* eslint-disable react-refresh/only-export-components */
import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import type { CapaAction } from '@/api/capa/types';
import { AiSuggestionsBanner } from '@/app/(client)/slcp/-components/AiSuggestionsBanner';
import { AiSuggestionsDialog } from '@/app/(client)/slcp/-components/AiSuggestionsDialog';
import { SlcpCapaActionSheet } from '@/app/(client)/slcp/-components/SlcpCapaActionSheet';
import { SlcpCapaTable } from '@/app/(client)/slcp/-components/SlcpCapaTable';
import { SlcpFindingsCard } from '@/app/(client)/slcp/-components/SlcpFindingsCard';
import { useOverviewCapa } from '@/app/(client)/slcp/-hooks/useOverviewCapa';
import { useSlcpOverviewPage } from '@/app/(client)/slcp/-hooks/useSlcpOverviewPage';

export const Route = createFileRoute(
  '/(client)/slcp/(pages)/assessments/(details)/$assessmentId/overview/',
)({
  component: SlcpOverviewPage,
});

function SlcpOverviewPage() {
  const { assessmentId } = Route.useParams();
  const {
    t,
    assessment,
    capaTab,
    setCapaTab,
    suggestedDialogOpen,
    setSuggestedDialogOpen,
    suggestedItems,
    suggestedTotal,
    isSuggestedLoading,
    selectedSuggestedIds,
    toggleSuggestedSelection,
    toggleAllSuggested,
    isBulkSubmitting,
    handleBulkAdd,
    closeSuggestedDialog,
    filters: suggestedFilters,
    onFiltersChange: onSuggestedFiltersChange,
    hasNextPage: suggestedHasNextPage,
    isFetchingNextPage: suggestedIsFetchingNextPage,
    fetchNextPage: suggestedFetchNextPage,
    impactAreasData,
  } = useSlcpOverviewPage(assessmentId);

  const {
    capaPage,
    setCapaPage,
    capaRows,
    capaTotal,
    capaIsLoading,
    capaPageSize,
  } = useOverviewCapa(assessmentId, capaTab);

  const [selectedAction, setSelectedAction] = useState<CapaAction | null>(null);

  if (!assessment) return null;

  return (
    <div className='flex flex-col gap-4'>
      <AiSuggestionsBanner
        totalCount={suggestedTotal}
        onView={() => setSuggestedDialogOpen(true)}
        t={t}
      />

      <SlcpFindingsCard assessmentId={assessmentId} t={t} />

      <SlcpCapaTable
        rows={capaRows}
        total={capaTotal}
        isLoading={capaIsLoading}
        page={capaPage}
        pageSize={capaPageSize}
        onPageChange={setCapaPage}
        activeTab={capaTab}
        onTabChange={setCapaTab}
        onRowClick={setSelectedAction}
        t={t}
      />

      <SlcpCapaActionSheet
        open={!!selectedAction}
        onClose={() => setSelectedAction(null)}
        action={selectedAction}
        t={t}
      />

      <AiSuggestionsDialog
        open={suggestedDialogOpen}
        onClose={closeSuggestedDialog}
        items={suggestedItems}
        total={suggestedTotal}
        isLoading={isSuggestedLoading}
        selectedIds={selectedSuggestedIds}
        onToggle={toggleSuggestedSelection}
        onToggleAll={toggleAllSuggested}
        isSubmitting={isBulkSubmitting}
        onSubmit={handleBulkAdd}
        filters={suggestedFilters}
        onFiltersChange={onSuggestedFiltersChange}
        hasNextPage={suggestedHasNextPage}
        isFetchingNextPage={suggestedIsFetchingNextPage}
        onFetchNextPage={suggestedFetchNextPage}
        impactAreas={impactAreasData}
        t={t}
      />
    </div>
  );
}
